import React, { useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

// Set worker URL using the specific version matched with react-pdf
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const PdfHighlighter = ({ fileUrl, pageNumber, bbox }) => {
  const [numPages, setNumPages] = useState(null);
  const [renderedWidth, setRenderedWidth] = useState(0);
  const [renderedHeight, setRenderedHeight] = useState(0);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  function onPageLoadSuccess(page) {
    setRenderedWidth(page.width || page.originalWidth);
    setRenderedHeight(page.height || page.originalHeight);
  }

  const highlightStyle = bbox ? {
    position: 'absolute',
    left: `${bbox.left * renderedWidth}px`,
    top: `${bbox.top * renderedHeight}px`,
    width: `${bbox.width * renderedWidth}px`,
    height: `${bbox.height * renderedHeight}px`,
    backgroundColor: 'rgba(255, 193, 7, 0.4)', // Amber highlight
    border: '2px solid #FFC107',
    pointerEvents: 'none',
    zIndex: 10,
    borderRadius: '4px',
    boxShadow: '0 0 10px rgba(255, 193, 7, 0.6)'
  } : { display: 'none' };

  return (
    <div className="pdf-viewer-container" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', height: '100%', overflowY: 'auto', padding: '20px', backgroundColor: '#f0f2f5' }}>
      <Document
        file={fileUrl}
        onLoadSuccess={onDocumentLoadSuccess}
        loading={<div style={{ padding: '20px' }}>Loading PDF...</div>}
        error={<div style={{ padding: '20px', color: 'red' }}>Failed to load source document.</div>}
      >
        <div style={{ position: 'relative', display: 'inline-block', boxShadow: '0 10px 25px rgba(0,0,0,0.1)' }}>
          {pageNumber && (
            <>
              <Page 
                pageNumber={pageNumber} 
                onLoadSuccess={onPageLoadSuccess}
                renderTextLayer={true}
                renderAnnotationLayer={true}
                scale={1.2}
              />
              {bbox && renderedWidth > 0 && (
                <div style={{...highlightStyle, left: `${bbox.left * renderedWidth * 1.2}px`, top: `${bbox.top * renderedHeight * 1.2}px`, width: `${bbox.width * renderedWidth * 1.2}px`, height: `${bbox.height * renderedHeight * 1.2}px`}} />
              )}
            </>
          )}
        </div>
      </Document>
      {numPages && (
        <div style={{ marginTop: '15px', fontWeight: '500', color: '#555' }}>
          Page {pageNumber || 1} of {numPages}
        </div>
      )}
    </div>
  );
};

export default PdfHighlighter;
